module.exports = __webpack_public_path__ + "assets/img/pizza_active.5e22f486.png";